// This should be updated automatically on each build
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
export const BUILD_TIME = import.meta.env.VITE_BUILD_TIME || new Date().toISOString();
